import ENV from './env';
import * as Yup from 'yup';
export const API_URL = ENV.API_BASE_PATH;

export enum WIDTH_KEYS {
	XS = 'XS',
	SM = 'SM',
	MD = 'MD',
	LG = 'LG',
	XL = 'XL',
	XXL = 'XXL',
	XXXL = 'XXXL'
}

export const SOURCE_HEADERS = ['x-source-id', '24680'];
export const TOKEN_KEY = 'access-token';
export const REFRESH_TOKEN_KEY = 'refresh-token';
export const TOKEN_THRESHOLD_KEY = 'access-token-threshold';
export const USER_TYPE = 'user-type';

/* eslint-disable */
export const EMAIL_REGEX =
	/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
export const PASSWORD_REGEX = /.{8,}/;
export const PHONE_REGEX = /^[0-9]{10}$/;
export const OTP_REGEX = /^[0-9]{6}$/;
export const YOUTUBE_LINK_REGEX =
	/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:v\/|embed\/|watch\?v=)|youtu\.be\/)([^\s&?/]+)/;
/* eslint-enable */

export const noop = (...arg: any): void => {
	// Do Nothing
};

// 26 Aug 2023, 09:33 PM
export const DATE_FNS_TIME_FORMAT = 'dd LLL yyyy, hh:mm aa';

export enum COLOR_KEYS {
	PRIMARY = '#064fd4',
	SECONDARY = '#64748b',
	SUCCESS = '#22c55e', // green
	INFO = '#0ea5e9',

	HELP = '#a855f7', // purple
	PROGRESS = '#0d3b66', // blue

	WARNING = '#ee964b', // yellow
	CRITICAL = '#f95738', // orange
	DANGER = '#ff3232', // red

	TERMINAL = '#a57548' // off-white
}

export const REQUIRED_MESSAGE = 'This field is required';
export const SINGLE_SELECT_FIELD_VALIDATION = Yup.object();
export const DOCUMENT_UPLOAD_MAX_SIZE = 10485760; // 10 MB
export const FILE_UPLOAD_MESSAGE = 'Drag and drop here to upload files or choose';

export enum UPLOAD_TYPE_KEYS {
	UPLOAD_VIDEO = 'UPLOAD_VIDEO',
	YOUTUBE_LINK = 'YOUTUBE_LINK',
	DOCUMENT = 'DOCUMENT'
}

export const UPLOAD_TYPES = {
	[UPLOAD_TYPE_KEYS.UPLOAD_VIDEO]: {
		key: UPLOAD_TYPE_KEYS.UPLOAD_VIDEO,
		label: 'Upload Video'
	},
	[UPLOAD_TYPE_KEYS.YOUTUBE_LINK]: {
		key: UPLOAD_TYPE_KEYS.YOUTUBE_LINK,
		label: 'Youtube Link'
	},
	[UPLOAD_TYPE_KEYS.DOCUMENT]: {
		key: UPLOAD_TYPE_KEYS.DOCUMENT,
		label: 'Document'
	}
};

export enum REFERENCE_TYPE_KEYS {
	PRODUCT = 'PRODUCT',
	INSPIRATION = 'INSPIRATION',
	PROJECT = 'PROJECT'
}

export const enum PERMISSIONS {
	ADMIN = 'ADMIN',

	DOCUMENT_EDIT = 'DOCUMENT_EDIT',
	DOCUMENT_READ = 'DOCUMENT_READ',

	INSPIRATION_EDIT = 'INSPIRATION_EDIT',
	INSPIRATION_READ = 'INSPIRATION_READ',

	LEAD_EDIT = 'LEAD_EDIT',
	LEAD_READ = 'LEAD_READ',

	PRODUCT_EDIT = 'PRODUCT_EDIT',
	PRODUCT_READ = 'PRODUCT_READ',

	PROJECT_EDIT = 'PROJECT_EDIT',
	PROJECT_READ = 'PROJECT_READ',

	SCHEDULER_EDIT = 'SCHEDULER_EDIT',
	SCHEDULER_READ = 'SCHEDULER_READ',

	USER_EDIT = 'USER_EDIT',
	USER_READ = 'USER_READ',

	APPROVAL_READ = 'APPROVAL_READ',
	APPROVAL_EDIT = 'APPROVAL_EDIT',

	COMMERCIAL_READ = 'COMMERCIAL_READ',
	COMMERCIAL_EDIT = 'COMMERCIAL_EDIT',

	QUOTATIONS_READ = 'QUOTATIONS_READ',
	QUOTATIONS_EDIT = 'QUOTATIONS_EDIT',

	CATEGORIES_READ = 'CATEGORIES_READ',
	CATEGORIES_EDIT = 'CATEGORIES_EDIT',

	WARRANTY_READ = 'WARRANTY_READ',
	WARRANTY_EDIT = 'WARRANTY_EDIT',

	TICKET_READ = 'TICKET_READ',
	TICKET_EDIT = 'TICKET_EDIT',

	CALENDAR_READ = 'CALENDAR_READ',
	CALENDAR_EDIT = 'CALENDAR_EDIT',

	COSTING_READ = 'COSTING_READ',
	COSTING_EDIT = 'COSTING_EDIT',

	PROFILE_READ = 'PROFILE_READ',
	PROFILE_EDIT = 'PROFILE_EDIT',

	LEAD_DETAILS_READ = 'LEAD_DETAILS_READ',
	LEAD_DETAILS_EDIT = 'LEAD_DETAILS_EDIT',

	DASHBOARD_READ = 'DASHBOARD_READ',

	PROMO_CODE_READ = 'PROMO_CODE_READ',
	PROMO_CODE_EDIT = 'PROMO_CODE_EDIT',

	ELECTRICAL_READ = 'ELECTRICAL_READ',
	ELECTRICAL_EDIT = 'ELECTRICAL_EDIT'
}

/** Shared layout for New Project step 0 (project details) and step 1 (floor plan upload). */
export const NEW_PROJECT_STEP_MAX_WIDTH_CLASS = 'max-w-[700px]';
export const NEW_PROJECT_STEP_SHELL_CLASS = `flex w-full min-w-0 flex-col mx-4 mt-2 mb-3 md:mx-auto md:mt-[20px] md:mb-0 ${NEW_PROJECT_STEP_MAX_WIDTH_CLASS} rounded-xl md:rounded-2xl md:shadow-md h-full md:h-fit flex-1 md:flex-none md:bg-[var(--pages-bg)]`;
/** Floor plan upload + PDF review: fills parent height so inner content can scroll. */
export const NEW_PROJECT_STEP_SHELL_SCROLLABLE_CLASS = `flex w-full min-w-0 flex-col mx-4 mt-2 mb-3 md:mx-auto md:mt-[20px] md:mb-0 ${NEW_PROJECT_STEP_MAX_WIDTH_CLASS} rounded-xl md:rounded-2xl md:shadow-md min-h-0 flex-1 overflow-hidden md:bg-[var(--pages-bg)]`;
export const NEW_PROJECT_STEP_INNER_SURFACE_CLASS =
	'flex w-full min-w-0 flex-1 flex-col overflow-hidden bg-[var(--pages-bg)] shadow-lg md:bg-none rounded-2xl md:shadow-none';
export const NEW_PROJECT_STEP_BODY_PADDING_CLASS = 'px-8 pt-8 box-border';
export const NEW_PROJECT_STEP_FOOTER_PADDING_CLASS = 'px-8 pb-8 pt-4 box-border';
export const NEW_PROJECT_STEP_CONTENT_STACK_CLASS = 'flex w-full min-w-0 flex-col gap-8';
export const NEW_PROJECT_STEP_MODAL_HEADER_PADDING_CLASS =
	'px-8 pt-8 pb-4 bg-[var(--pages-bg)] border-b border-[var(--border-default)] text-[var(--black0)]';
export const NEW_PROJECT_STEP_MODAL_CONTENT_PADDING_CLASS = 'px-8 pb-2 bg-[var(--pages-bg)] text-[var(--black0)]';
export const NEW_PROJECT_STEP_MODAL_FOOTER_PADDING_CLASS =
	'px-8 pb-8 pt-4 bg-[var(--pages-bg)] border-t border-[var(--border-default)]';

